/**
 * Dev-only tracing for the single-session guard. Mirrored from
 * `bimgo-ai-web/client/src/lib/authDebug.ts`.
 *
 * The guard is hard to observe from outside: GoTrue makes the sign-out decision,
 * the trigger arrives over a WebSocket, and the channel lifecycle swallows its
 * own errors so one failure cannot poison later subscriptions. Without this you
 * cannot tell "the broadcast never arrived" from "it arrived and the server said
 * the session is still fine" — opposite problems with opposite fixes.
 *
 * `import.meta.env.DEV` is replaced at build time, so none of this ships.
 */
export function authLog(...args: unknown[]): void {
  if (import.meta.env.DEV) {
    console.log("[session-guard]", ...args);
  }
}
